<template>
  <div class="fliters margin-between-section">
    <div class="row not-margin">
      <div class="col-md-12 container-info">
        <div class="row info margin-zero">
          <div class="col-lg-2 padding-zero">
            <h1 class="btn-f-m-h1"><img src="../assets/images/filter.png" /> {{ $t('playerFilter.filters') }}</h1>
            <button v-on:click="showFilter = !showFilter" class="btn-f-m"><img src="../assets/images/filter.png" /> {{ $t('playerFilter.filters') }} <img class="arrow-down" src="../assets/images/arrow_down.png" /> </button>
            <button type="btn" v-on:click="createPlayer" class="btn btn-action desktop-filter create-player">{{ $t('playerFilter.upload') }}</button>
            <button type="btn" v-on:click="appFilter" class="btn btn-action desktop-filter app-filter">{{ $t('playerFilter.apply') }}</button>
            <button type="btn" v-on:click="cleanFilter" class="btn btn-action desktop-filter clear-filter">{{ $t('playerFilter.clean_filters') }}</button>
          </div>

          <div class="col-lg-10 padding-zero">
            <div v-bind:class="{'show-mobile-filters' : showFilter == true}" class="padding-zero menu">
              <div class="c-header">
                
                <div class="container-age">
                  <div class="con-i" style="white-space:nowrap">
                    <label class="title-value" for="id1">{{ $t('playerFilter.age') }}:</label>
                    <input @keypress="isNumber($event)" v-model="minAge" type="text" id="minima"  maxlength="2" :placeholder="$t('playerFilter.ageMin')" />
                    <input @keypress="isNumber($event)" v-model="maxAge" type="text" id="maxima"  maxlength="2" :placeholder="$t('playerFilter.ageMax')" />
                  </div>
                  <div class="show-mobile container-drop-mob">
                    <!--<div class="dropdown">
                      <template class="btn-d">
                        <select v-if="$t('flag.flag') == 'es'" v-model="nacionalidad" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('playerFilter.nacionality') }}</option>
                          <option v-for="item in countries" :key="item.id" :value=item.pais >{{item.pais}}</option>
                        </select>
                        <select v-else v-model="nacionalidad" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('playerFilter.nacionality') }}</option>
                          <option v-for="item in countries" :key="item.id" :value=item.pais_eng >{{item.pais_eng}}</option>
                        </select>

                      </template>
                    </div>
                    <div class="dropdown">
                      <template class="btn-d">
                        <select v-if="$t('flag.flag') == 'es'" v-model="pasaporte" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('playerFilter.passport') }}</option>
                          <option v-for="item in countries" :key="item.id" :value=item.gentilicio >{{item.gentilicio}}</option>
                        </select>
                        <select v-else v-model="pasaporte" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('playerFilter.passport') }}</option>
                          <option v-for="item in countries" :key="item.id" :value=item.gentilicio_eng >{{item.gentilicio_eng}}</option>
                        </select>

                      </template>
                    </div>-->
                    <div class="dropdown ">
                      <template class="btn-d">
                        <select v-model="pierna" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('playerFilter.foot') }}</option>
                          <option :value="$t('playerFilter.footLeft')">{{ $t('playerFilter.footLeft') }}</option>
                          <option :value="$t('playerFilter.footRight')">{{ $t('playerFilter.footRight') }}</option>
                          <option :value="$t('playerFilter.footBoth')">{{ $t('playerFilter.footBoth') }}</option>
                        </select>
                      </template>
                    </div>
                    <div class="dropdown">
                      <template class="btn-d">
                        <select v-model="cost" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('admin.cost')}}</option>
                          <option v-for="item in costList" :key="item.id" :value=item.value >{{item.position}}</option>
                        </select>
                      </template>
                    </div>
                  </div>
                  <div class="container-options-position">
                    <div class="def camp-position margin-between-section">
                      <p class="instruction-position">{{ $t('playerFilter.defense') }}:</p>
                      <ul v-if="$t('flag.flag') == 'es'">
                        <li v-for="item in jsonDefEsp" :key="item.id">
                          <button @mouseover="position(item.value)" v-on:click="positionSelected(item.position, item.position, item.value)" :id="item.position" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.positionEsp }}</button>
                        </li>
                      </ul>
                      <ul v-else>
                        <li v-for="item in jsonDef" :key="item.id">
                          <button @mouseover="position(item.value)" v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.position }}</button>
                        </li>
                      </ul>
                    </div>
                    <div class="def camp-position">
                      <p class="instruction-position">{{ $t('playerFilter.midfield') }}:</p>
                      <ul v-if="$t('flag.flag') == 'es'">
                        <li v-for="item in jsonMedEsp" :key="item.id">
                          <button @mouseover="position(item.value)"  v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.positionEsp }}</button>
                        </li>
                      </ul>
                      <ul v-else>
                        <li v-for="item in jsonMed" :key="item.id">
                          <button @mouseover="position(item.value)" v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.position }}</button>
                        </li>
                      </ul>
                    </div>
                    <div class="def camp-position">
                      <p class="instruction-position">{{ $t('playerFilter.forward') }}:</p>
                      <ul v-if="$t('flag.flag') == 'es'">
                        <li v-for="item in jsonDelEsp" :key="item.id">
                          <button @mouseover="position(item.value)"  v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.positionEsp }}</button>
                        </li>
                      </ul>
                      <ul v-else>
                        <li v-for="item in jsonDel" :key="item.id">
                          <button @mouseover="position(item.value)" v-on:click="positionSelected(item.position, item.position, item.value)" :class="{'active-btn-gray': isClicked[item.position]}" class="btn btn-position">{{ item.position }}</button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <button type="btn" v-if="filter == 1" v-on:click="appFilter" class="btn btn-action desktop-filter-tab">{{ $t('playerFilter.apply') }}</button>
                  <button type="btn" v-if="filter == 0" v-on:click="cleanFilter" class="btn btn-action desktop-filter-tab">{{ $t('playerFilter.clean_filters') }}</button>
                </div>

                <div class="container-drop">
                  
                  <div class="show-desktop content-drop filter-text-options">
                    <!--<div class="dropdown f-l">
                      <template class="btn-d">
                        
                        <select v-if="$t('flag.flag') == 'es'" v-model="nacionalidad" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('playerFilter.nacionality') }}</option>
                          <option v-for="item in countries" :key="item.id" :value=item.pais >{{item.pais}}</option>
                        </select>
                        <select v-else v-model="nacionalidad" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('playerFilter.nacionality') }}</option>
                          <option v-for="item in countries" :key="item.id" :value=item.pais_eng >{{item.pais_eng}}</option>
                        </select>

                      </template>
                    </div>
                    <div class="dropdown">
                      <template class="btn-d">
                        <select v-if="$t('flag.flag') == 'es'" v-model="pasaporte" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('playerFilter.passport') }}</option>
                          <option v-for="item in countries" :key="item.id" :value=item.gentilicio >{{item.gentilicio}}</option>
                        </select>
                        <select  v-else  v-model="pasaporte" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('playerFilter.passport') }}</option>
                          <option v-for="item in countries" :key="item.id" :value=item.gentilicio_eng >{{item.gentilicio_eng}}</option>
                        </select>
                      </template>
                    </div>-->
                    <div class="dropdown">
                      <template class="btn-d">
                        <select v-model="pierna" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('playerFilter.foot') }}</option>
                          <option :value="$t('playerFilter.footLeft')">{{ $t('playerFilter.footLeft') }}</option>
                          <option :value="$t('playerFilter.footRight')">{{ $t('playerFilter.footRight') }}</option>
                          <option :value="$t('playerFilter.footBoth')">{{ $t('playerFilter.footBoth') }}</option>
                        </select>
                      </template>
                    </div>
                    <div class="dropdown">
                      <template class="btn-d">
                        <select v-model="cost" class="browser-default custom-select btn-d">
                          <option selected value="">{{ $t('admin.cost')}}</option>
                          <option v-for="item in costList" :key="item.id" :value=item.value >{{item.position}}</option>
                        </select>
                      </template>
                    </div>
                  </div>

                  <div class="container-footer-drop">
                    <div class="map-area-container">
                      <div class="map-area">                  
                        <div class="cb-position" :class="{'d-block-hover': positionCB == true, 'd-block': isClicked['cb']}"></div>
                          <div class="lb-position" :class="{'d-block-hover': positionLB == true, 'd-block': isClicked['lb']}"></div>
                          <div class="rb-position" :class="{'d-block-hover': positionRB == true, 'd-block': isClicked['rb']}"></div>
                          <div class="lwb-position" :class="{'d-block-hover': positionLWB == true, 'd-block': isClicked['lwb']}"></div>
                          <div class="rwb-position" :class="{'d-block-hover': positionRWB == true, 'd-block': isClicked['rwb']}"></div>
                          <div class="dm-position" :class="{'d-block-hover': positionDM == true, 'd-block': isClicked['dm']}"></div>
                          <div class="lm-position" :class="{'d-block-hover': positionLM == true, 'd-block': isClicked['lm']}"></div>
                          <div class="cm-position" :class="{'d-block-hover': positionCM == true, 'd-block': isClicked['cm']}"></div>
                          <div class="rm-position" :class="{'d-block-hover': positionRM == true, 'd-block': isClicked['rm']}"></div>
                          <div class="am-position" :class="{'d-block-hover': positionAM == true, 'd-block': isClicked['am']}"></div>
                          <div class="s-position" :class="{'d-block-hover': positionS == true, 'd-block': isClicked['s']}"></div>
                      </div>
                    </div>
                  </div>
                  <div class="content-options skil">
                    <div class="opt-radio content-radio-phy">
                      <label class="title-value" for="id1">{{ $t('playerFilter.physical') }}</label>
                      
                      <div class="radio">
                        <label><input type="checkbox" v-model="physical"  value="Pace" name="optradio">{{ $t('playerFilter.pace') }}</label>
                      </div>
                      <div class="radio">
                        <label><input type="checkbox" v-model="physical"  value="Power"  name="optradio">{{ $t('playerFilter.power') }}</label>
                      </div>
                      <div class="radio">
                        <label><input type="checkbox" v-model="physical" value="Agility" name="optradio">{{ $t('playerFilter.agility') }}</label>
                      </div>
                      <div class="radio">
                        <label><input type="checkbox" v-model="physical" value="Aerial play" name="optradio">{{ $t('playerFilter.aerial_play') }}</label>
                      </div>
                      <div class="radio">
                        <label><input type="checkbox" v-model="physical" value="Energy" name="optradio">{{ $t('playerFilter.energy') }}</label>
                      </div>

                    </div>
                    <div class="opt-radio content-radio-tac">
                      <label class="title-value" for="id1">{{ $t('playerFilter.technical') }}:</label>
                      <div class="radio">
                        <label><input type="checkbox" v-model="technical" value="Passing" name="optradio">{{ $t('playerFilter.passing') }}</label>
                      </div>
                      <div class="radio">
                        <label><input type="checkbox" v-model="technical" value="Defending" name="optradio">{{ $t('playerFilter.defending') }}</label>
                      </div>
                      <div class="radio">
                        <label><input type="checkbox" v-model="technical" value="Dribbling" name="optradio">{{ $t('playerFilter.dribbling') }}</label>
                      </div>
                      <div class="radio">
                        <label><input type="checkbox" v-model="technical" value="Finishing" name="optradio">{{ $t('playerFilter.finishing') }}</label>
                      </div>
                      <div class="radio">
                        <label><input type="checkbox" v-model="technical" value="Awareness" name="optradio">{{ $t('playerFilter.awareness') }}</label>
                      </div>
                    </div> 
                  </div>
                </div>
              </div>
              <div v-if="showFilter" class="appFilterMo">
                <button type="btn" v-on:click="createPlayer" class="btn btn-action create-player">{{ $t('playerFilter.upload') }}</button>
                <button v-on:click="appFilter" class="btn-action app-filter">{{ $t('playerFilter.apply') }}</button>
                <button type="btn" v-on:click="cleanFilter" class="clear-filter btn-action">{{ $t('playerFilter.clean_filters') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--<p class="error"> {{error}}</p>-->
    <div class="not-margin">
      <Players />
    </div>
  </div>
</template>

<script>

import Players from '@/components/PlayersAdmin';
import countries from "@/assets/data/countries.json";
import { bus } from '../main'

export default {
  name: "adminPlayers",
    components: {
      Players
  },
  data() {
    return {
      activeBtn: '',
      isClicked: [],

      //-- Filters
      countries: countries,
      showFilter: false,
      minAge: "",
      maxAge: "",
      physical: [],
      technical: [],
      positionsPlayer: [],
      nacionalidad: "",
      pierna: "",
      pasaporte: "",
      error: "12",
      filter: 1,
      cost: "",
      
      //-- End filters
      jsonDef: [
        { position: "cb", value: 1 },
        { position: "lb", value: 2 },
        { position: "rb", value: 3 },
        { position: "lwb", value: 4 },
        { position: "rwb", value: 5 },
      ],
      jsonMed: [
        { position: "dm", value: 6 },
        { position: "lm", value: 7 },
        { position: "cm", value: 8 },
        { position: "rm", value: 9 },
        { position: "am", value: 10 },
      ],
      jsonDel: [
        { position: "s", value: 11 }
      ],
      jsonDefEsp: [
        { position: "cb", positionEsp: "dfc", value: 1 },
        { position: "lb", positionEsp: "li", value: 2 },
        { position: "rb", positionEsp: "ld", value: 3 },
        { position: "lwb", positionEsp: "cri", value: 4 },
        { position: "rwb", positionEsp: "crd", value: 5 },
      ],
      jsonMedEsp: [
        { position: "dm", positionEsp: "md", value: 6 },
        { position: "lm", positionEsp: "exi", value: 7 },
        { position: "cm", positionEsp: "mc", value: 8 },
        { position: "rm", positionEsp: "exd", value: 9 },
        { position: "am", positionEsp: "mo", value: 10 },
      ],
      jsonDelEsp: [
        { position: "s", positionEsp: "del", value: 11 }
      ],
      costList: [
        { position: "0 - 100k", value: 1 },
        { position: "100k - 300k", value: 2 },
        { position: "300k - 500k", value: 3 },
        { position: "> 500k", value: 4 }
      ],
      positionGK: false,
      positionCB: false,
      positionLB: false,
      positionRB: false,
      positionLWB: false,
      positionRWB: false,
      positionDM: false,
      positionLM: false,
      positionCM: false,
      positionRM: false,
      positionAM: false,
      positionS: false,
    };
  },

  created(){
    if(localStorage.idiom){
      this.idiom = localStorage.idiom
    }
    /*bus.$on("change_array", (value) => {
      this.newPostion()
    });*/
  },
  beforeMount(){

    /*this.jsonDef = [
        { position: this.$t('playerFilter.cb'), value: 1 },
        { position: this.$t('playerFilter.lb'), value: 2 },
        { position: this.$t('playerFilter.rb'), value: 3 },
        { position: this.$t('playerFilter.lwb'), value: 4 },
        { position: this.$t('playerFilter.rwb'), value: 5 },
      ]
    this.jsonMed = [
        { position: this.$t('playerFilter.dm'), value: 6 },
        { position: this.$t('playerFilter.cm'), value: 7 },
        { position: this.$t('playerFilter.am'), value: 8 },
        { position: this.$t('playerFilter.lm'), value: 9 },
        { position: this.$t('playerFilter.rm'), value: 10 },
      ]
    this.jsonDel = [
        { position: this.$t('playerFilter.s'), value: 11 }
    ]*/
  },
  methods: {
    /*newPostion(){
      this.jsonDef = [
        { position: this.$t('playerFilter.cb'), value: 1 },
        { position: this.$t('playerFilter.lb'), value: 2 },
        { position: this.$t('playerFilter.rb'), value: 3 },
        { position: this.$t('playerFilter.lwb'), value: 4 },
        { position: this.$t('playerFilter.rwb'), value: 5 },
      ]
    this.jsonMed = [
        { position: this.$t('playerFilter.dm'), value: 6 },
        { position: this.$t('playerFilter.cm'), value: 7 },
        { position: this.$t('playerFilter.am'), value: 8 },
        { position: this.$t('playerFilter.lm'), value: 9 },
        { position: this.$t('playerFilter.rm'), value: 10 },
      ]
    this.jsonDel = [
        { position: this.$t('playerFilter.s'), value: 11 }
      ]
    },*/
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    position (item) {

        this.positionCB = false,
        this.positionLB = false,
        this.positionRB = false,
        this.positionLWB = false,
        this.positionRWB = false,
        this.positionDM = false,
        this.positionLM = false,
        this.positionCM = false,
        this.positionRM = false,
        this.positionAM = false,
        this.positionS = false

      switch (item) {
        
        case 1:
          this.positionCB = true
          break;
        
        case 2:
          this.positionLB = true
          break;
        
        case 3:
          this.positionRB = true
          break;

        case 4:
          this.positionLWB = true
          break;

        case 5:
          this.positionRWB = true
          break;

        case 6:
          this.positionDM = true
          break;
        case 7:
          this.positionLM = true
          break;

        case 8:
          this.positionCM = true
          break;

        case 9:
          this.positionRM = true
          break;

        case 10:
          this.positionAM = true
          break;

        case 11:
          this.positionS = true
          break;
      
        default:
          break;
      }
    },
    positionSelected(position, index, item){
  
      this.$set(this.isClicked, index, !this.isClicked[index])

      const searchElement = document.querySelector('#' + position);

      //document.removeEventListener("mouseover", this.deleteTask);

      const found = this.positionsPlayer.find(element => element == position);

      if(typeof found == "undefined"){
        this.positionsPlayer.push(position)
      } else{
        this.removeA(this.positionsPlayer, position);
      }
    },
    removeA(arr) {
      
      let what, a = arguments, L = a.length, ax;// eslint-disable-line
    
      while (L > 1 && arr.length) {
          what = a[--L];
          while ((ax= arr.indexOf(what)) !== -1) {
              arr.splice(ax, 1);
          }
      }
      return arr;
    },
    save(){
      console.log("Save") 
    },

    appFilter(){
      

      this.notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.filtering')
      }

      bus.$emit('upload', this.notification)

      /*if(parseInt(this.minAge) > parseInt(this.maxAge)){

        this.error = "La edad minima no puede ser mayor a la maxima."
        return
      }

      this.error = ""*/


      this.showFilter = false
      const params = {
        ageMin: parseInt(this.minAge) || undefined,
        ageMax:  parseInt(this.maxAge) || undefined,
        nationality: this.nacionalidad,
        passports: this.pasaporte ? [this.pasaporte] : [],
        foot: this.pierna,
        positions: this.positionsPlayer,
        physical: this.physical,
        technical: this.technical,
        cost: this.cost
      }

      bus.$emit('filter', params);
      this.filter = 0

    },

    cleanFilter(){

      this.notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.filtering')
      }

      bus.$emit('upload', this.notification)

      this.filter = 1
      this.showFilter = false,
      this.minAge =  "",
      this.maxAge = "",
      this.physical = [],
      this.technical = [],
      this.positionsPlayer = [],
      this.nacionalidad = "",
      this.isClicked = [],
      this.pierna = "",
      
      this.pasaporte =  ""
      this.cost = ""

      const params = {
        ageMin: parseInt(this.minAge) || undefined,
        ageMax:  parseInt(this.maxAge) || undefined,
        nationality: this.nacionalidad,
        passports: this.pasaporte ? [this.pasaporte] : [],
        foot: this.pierna,
        positions: this.positionsPlayer,
        physical: this.physical,
        technical: this.technical,
      }

      bus.$emit('filter', params);
    },

    createPlayer(){
      this.$router.push('/create-player')
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.f-l{
  float: left;
}

.f-r{
  float: right;
}

.filter-text-options{
  text-align: center;
}

.active-btn-gray {
  background: #000;
  color: #fff;
}

.container-drop-mob{
  padding-bottom: 20px;
  overflow: hidden;
}

.btn-f-m-h1{
  display: block
}

.desktop-filter{
  display: block;
}

.desktop-filter-tab{
  display: none;
}

.show-desktop{
  display: block;
}

.show-mobile{
  display: none;
}

.content-drop{
  display: none;
}

.show-desk{
  display: block;
}

.custom-select {
  margin-top: 10px;
  background: #fff url("../assets/images/arrow_down.png") no-repeat right .75rem center/8px 10px;
  border: 1px solid #000;
  border-radius: 0;
}

.custom-select:focus{
  border-color: #000;
  box-shadow: none
}

.custom-select option {
    font-weight: 123px;
}


.show-mo{
  display: none;
}



.btn-f-m{
  display: none;
}


.radio input, .checkbox input {
  cursor: pointer;
  margin-right: 10px;
}

.content-drop{
  display: block;
  text-align: left;
  margin: 0 15px;
}

.content-options{
  position: relative;
  display: inline-block;
  width: 50%;
  text-align: center;
  margin-top: 25px;
}

.opt-radio{
  display: inline-block;
  text-align: left;
  margin: 0 1%;
  width: 40%;
}


.title-value{
  font-size: 12px;
  display: block;
}

.radio + .radio {
  margin: 0;
}

.radio, .checkbox {
  display: block;
  margin: 0;
}

.radio label, .checkbox label{
  font-size: 11px;
  font-weight: 600;
  text-decoration: underline;
}


/* Position */

.d-block-hover{
  display: block !important;
}

.d-block{
  display: block !important;
}

.cb-position{
  position: absolute;
  width: 81.5px;
  height: 75px;
  left: 7px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
  display: none;
}

.lb-position{
  position: absolute;
  width: 81.5px;
  height: 50px;
  left: 7px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
  display: none;
}


.rb-position{
  position: absolute;
  width: 81.5px;
  height: 51px;
  left: 7px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
    display: none;
}

.lwb-position{
  position: absolute;
  width: 91.5px;
  height: 50px;
  left: 89px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
  display: none;
}


.rwb-position{
  position: absolute;
  width: 91.5px;
  height: 50px;
  left: 89px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
  display: none;
}

.dm-position{
  position: absolute;
  width: 45px;
  height: 76px;
  left: 89px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
  display: none;
}

.lm-position{
  position: absolute;
  width: 81px;
  height: 50px;
  left: 181px;
  background: rgba(139, 139, 139, 0.24);
  top: 0;
  opacity: 0.6;
  display: none;
}

.cm-position{
  position: absolute;
  width: 44.5px;
  height: 76px;
  left: 136px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
  display: none;
}

.rm-position{
  position: absolute;
  width: 81px;
  height: 50px;
  left: 181px;
  background: rgba(139, 139, 139, 0.24);
  bottom: 0;
  opacity: 0.6;
  display: none;
}

.am-position{
  position: absolute;
  width: 45px;
  height: 76px;
  left: 181px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
  display: none;
}

.s-position{
  position: absolute;
  width: 35px;
  height: 76px;
  left: 227px;
  background: rgba(139, 139, 139, 0.24);
  top: 50px;
  opacity: 0.6;
  display: none;
}

.gk-map{
  position: absolute;
  width: 31px;
  height: 50px;
  left: 0px;
  background: green;
  top: 102px;
  opacity: 0.6;
  display: none;
}

.lat-i-map{
  position: absolute;
  width: 390px;
  height: 50px;
  left: 0;
  background: blue;
  top: 0;
  opacity: 0.6;
}

.lat-d-map{
  position: absolute;
  width: 390px;
  height: 50px;
  left: 0;
  background: red;
  bottom: 0;
  opacity: 0.6;
}

.def-map{
  position: absolute;
  width: 129px;
  height: 253px;
  left: 0;
  background: black;
  opacity: 0.6;
}

.med-map{
  position: absolute;
  width: 129px;
  height: 253px;
  margin-left: 130px;
  background: purple;
  opacity: 0.6;
}

.del-map{
  position: absolute;
  width: 129px;
  height: 253px;
  right: 0;
  background: orange;
  opacity: 0.6;
}

.map-area-container{
  background-color: #fff;
  width: 270px;
  height: 176px;
  position: relative;
  z-index: 1;
  margin-top: 10px;
  margin-left: 10px;
}

.map-area{
  background: url(/img/camp.10dfa781.png)no-repeat;
  width: 270px;
  height: 176px;
  position: relative;
  background-size: 270px;
}


.app-filter{
  margin-bottom: 40px;
}

.create-player{
  margin-bottom: 80px;
}

.btn-action{
  background: #fff;
  color: #000;
  border: 1px solid #000;
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
  border-radius: 0;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 150px;
}


ul {
  text-decoration: none;
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  margin-right: 10%;
  display: inline;
}

.btn-position {
  font-size: 10px;
  border-bottom: 1px solid #000;
  width: 25px;
  padding: 0;
  margin-right: 5px;
  text-transform: uppercase;
  font-family: "plain medium", arial;
}

.margin-zero {
  margin: 0;
}
.padding-zero {
  padding: 0;
}

.c-header {
  width: 100%;
  margin-top: 5%;
}

.info {
  text-align: left;
  width: 100%;
}

.info h1 {
  width: 90px;
  font-size: 20px;
  font-family: "plain regular", arial;
  float: left;
}

.container-age {
  display: inline-block;
  overflow: hidden;
  width: 38%;
}

.container-options-position{
  width: 100%;
}
.info h1 img {
  width: 20px;
}

.info p {
  font-size: 18px;
}

.container-info {
  display: flex;
}

.not-margin {
  margin: 0;
}
.not-padding {
  padding: 0;
}

.info-form-contact {
  text-align: left;
}

.info-form-contact h1 {
  font-size: 16px;
  font-family: "plain regular", arial;
}

.info-form-contact p {
  font-size: 8px;
  margin-top: 15px;
  color: rgb(151, 151, 151);
}

.info-form-contact a {
  font-size: 8px;
  margin-top: 15px;
  color: rgb(116, 116, 116);
  text-decoration: underline;
}

.con-i input {
  border: 0;
  border-bottom: 1px solid #000;
  width: 120px;
  font-size: 12px;
  margin-left: 5%;
}

.send-b {
  border: 1px solid #000;
  border-radius: 0;
  margin-left: 0px;
  font-size: 12px;
  padding: 5px 30px;
  margin-bottom: 9px;
}

.container-drop {
  width: 60%;
  float: right;
}

.dropdown {
  font-size: 13px;
  font-family: "plain regular", arial;
  height: 35px;
  width: 24%;
}

.dropdown-menu {
  border: 1px solid #000;
  border-radius: 0;
  margin: 0.125rem -1px 0;
}

.dropdown-toggle::after {
  margin-left: 5em;
}


.dropdown-toggle {
  font-size: 13px;
}

.dropdown-item {
  font-size: 13px;
}

.instruction {
  color: #000;
  font-size: 11px !important;
  font-family: "plain regular", arial;
}

.instruction-position {
  font-size: 12px !important;
}

.camp-position {
  position: relative;
  margin-top: 20px;
}

.container-footer-drop {
  position: relative;
  display: inline-block;
  float: left;
  margin-top: 20px;
}

.container-footer-drop img {
  display: inline-block;
  vertical-align: bottom;
}

.container-footer-drop p {
  display: inline-block;
}

.instruction-mapa {
  color: #000;
  font-size: 9px !important;
  width: 180px;
  margin-left: 10px;
}

.btn-d {
  padding: 0.5em;
  font-size: 12px;
}

.appFilterMo{
  display: none;
  margin-top: 110px;
}



/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {
  .content-options {
    width: 100%;
    text-align: left;
  }
  .dropdown {
    width: 45%;
    margin: 10px;
  }
}


/* Larger than desktop */
@media (max-width: 992px) {
  .iframe-content{
    width: 100%;
  }

  .c-user{
    width: 49%;
  }
  
  .desktop-filter{
    display: none;
  }

  .desktop-filter-tab{
    display: block;
  }

  .dropdown {
    width: 45%;
    margin: 10px;
  }

  .iframe-content{
    margin-top: 10px;
    position: relative;
  }

  .iframe-content iframe{
    width: 100%;
  }
  
}

/* Larger than tablet */
@media (max-width: 768px) {

  .create-player{
    margin-bottom: 80px;
  }

  .app-filter{
    margin-bottom: 40px;
  }

  .clear-filter{
    margin-bottom: 0px;
  }


  .desktop-filter-tab{
    display: none;
  }


  .show-desktop{
    display: none;
  }

  .show-mobile{
    display: block;
  }

  .container-drop {
    width: 100%;
    float: right;
  }


  .menu {
    clear: both;
    max-height: 0;
    transition: max-height .2s ease-out;
    overflow: hidden;
  }

  .desktop-filter{
    display: none;
  }

  .appFilterMo{
    display: block;
  }

  .container-age{
    width: 100%;
  }

  .show-desk{
    display: none;
  }

  .content-options{
    display: none;
  }

  .container-drop {
    float: initial;
    text-align: center;
  }

  .container-footer-drop{
    float: initial;
    margin: 20px auto;
  }

  .show-mo{
    display: block;
    overflow: hidden;
    padding-bottom: 20px;
    
  }

  .title-value{
    display: inline-block;
    width: 50px;
  }

  .dropdown{
    width: 48%;
    padding: 0;
    margin: 0;
    float: left;
    margin-top: 15px;
    margin-right: 0.5em;
    display: inline;
    
  }

  .dropdown + .dropdown {
    margin-left: 0em;
    
  }

  .btn-f-m-h1{
    display: none ;
  }

  .btn-f-m{
    display: block;
    width: 100%;
    border: none;
    text-align: left;
    background: #fff;
    margin-bottom: 20px;
    padding: 0;
  }
  
  .btn-f-m img{
    width: 25px;
    margin-right: 5px;
  }
  .arrow-down{
    width: 15px !important;
    float: right;
    margin-top: 5px;
  }

  .header .menu {
    clear: both;
    max-height: 0;
    transition: max-height .2s ease-out;
    overflow: hidden;
  }


  .show-mobile-filters {
    max-height: 1200px !important;
  }

  .iframe-content{
    width: 103%;
  }
  

}

/* Larger than phablet */
@media (max-width: 550px) {
}

/* Larger than mobile */
@media (max-width: 400px) {}


</style>